import { createSlice } from "@reduxjs/toolkit";

import { LOCAL_STORAGE_KEYS } from "../../Util/constants";

// import { v4 as uuidv4 } from "uuid";

// const session = localStorage.getItem(LOCAL_STORAGE_KEYS.SESSION_TOKEN);
const initialState = {};
export const authSlice = createSlice({
  name: LOCAL_STORAGE_KEYS.AUTH,
  initialState,
  reducers: {
    authSuccess: (state, action) => {
      state.authToken = action.payload;
    },
    // setEmailOtpCode: (state, action) => {
    //   state.emailOtpCode = action.payload;
    // },
    // startGame: (state, action) => {
    //   state.clickedPlay = true;
    // },
    // setEmailAccountCreateToken: (state, action) => {
    //   state.emailAccountCreationToken = action.payload;
    // },
    // setCaptchaAction: (state, action) => {
    //   state.captchaAction = action.payload;
    // },
    // setCaptchaToken: (state, action) => {
    //   state.captchaToken = action.payload;
    // },
    // setAuthEmail: (state, action) => {
    //   state.authEmail = action.payload;
    // },
    // setAuthPassword: (state, action) => {
    //   state.authPassword = action.payload;
    // },
    // setLoginModalScreen: (state, action) => {
    //   state.loginModalScreen = action.payload;
    // },
    // loginWithEmailStart: (state) => {
    //   state.loginInWithEmailInProgress = true;
    // },
    // submitTwitterCode: (state, action) => {
    //   state.twitterCode = action.payload;
    // },
    // authSuccess: (state, action) => {
    //   state.loginStatus = "SUCCESS";
    //   state.authToken = action.payload;
    //   state.authPassword = "";
    //   state.loginModalScreen = "default";
    //   state.loginInWithEmailInProgress = false;
    //   state.emailAccountCreationToken = null;
    //   state.postAuthActionTrigger = true;
    // },
    logout: (state) => {
      // state.clickedPlay = false;
      // state.loginStatus = null;
      state.authToken = '';
      // state.refreshToken = '';
      state.authEmail = '';
      // state.loginModalScreen = 'default';
      // state.deleteUserRequest = null;
      localStorage.removeItem(LOCAL_STORAGE_KEYS.AUTH);
    },
    // setAuthError: (state, action) => {
    //   state.authError = action.payload;
    //   state.loginInWithEmailInProgress = false;
    // },
    // closeAuthModal: (state) => {
    //   state.authError = null;
    //   state.authPassword = null;
    //   state.authEmail = null;
    //   state.loginModalScreen = "default";
    // },
    // startDeleteAccount: (state) => {
    //   state.deleteUserRequest = "start";
    // },
    // deleteAccountInProgress: (state) => {
    //   state.deleteUserRequest = "in_progress";
    // },
    // deleteAccountSuccess: (state) => {
    //   state.deleteUserRequest = "success";
    // },
    // deleteAccountError: (state) => {
    //   state.deleteUserRequest = "error";
    // },
    // clearDeleteAccountStatus: (state) => {
    //   state.deleteUserRequest = null;
    // },
    // setPostAuthAction: (state, action) => {
    //   state.postAuthAction = action.payload;
    // },
    // completedPostAuthAction: (state) => {
    //   state.postAuthActionTrigger = false;
    // },
  },
});


export const loadAuthFromLocalStorage = () => {
  const storedAuth = localStorage.getItem(LOCAL_STORAGE_KEYS.AUTH);
  console.log(storedAuth)
  if (!storedAuth) return authSlice.initialState;
  const newAuth = JSON.parse(storedAuth);
  console.log(newAuth)
  return newAuth;
};

export const saveAuthToLocalStorage = (auth) => {
  const authSlice = { ...auth };
  localStorage.setItem(LOCAL_STORAGE_KEYS.AUTH, JSON.stringify(authSlice));
};
// Action creators are generated for each case reducer function
export const { authSuccess, logout } = authSlice.actions;

export default authSlice.reducer;
